@if (tenant?.enabled_features?.new_onboarding) {
  <div
    [ngStyle]="{
      height: '100vh',
      'min-height': '665px',
      'overflow-x': 'hidden',
      'overflow-y': 'scroll',
    }"
    class="u-position-relative u-margin-center background-color-surface"
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    <app-onboarding-background-flair class="u-display-block" />
    @if (tenant) {
      @if (canLogIn) {
        <div
          [ngStyle]="{ width: '95vw', height: '95vh' }"
          fxLayoutAlign="center center"
        >
          <div
            [ngStyle]="{
              width: '750px',
              height: '60%',
              'min-height': '665px',
              'z-index': 5,
            }"
            class="u-borderRadius-card background-color-surface u-padding-40 u-overflow-auto mat-elevation-z4"
            fxLayout="column"
            fxLayoutAlign="space-between center"
          >
            <div
              [ngStyle]="{
                display: 'grid',
                'grid-template-rows': 'auto 1fr',
              }"
              class="u-width-100 u-height-100"
            >
              <div
                class="u-width-100"
                fxLayout="column"
                fxLayoutAlign="start center"
              >
                <app-avatar-tenant
                  [item]="tenant"
                  [size]="96"
                  class="u-display-block u-marginBottom-24"
                >
                </app-avatar-tenant>
                <h6
                  [ngStyle]="{ 'text-align': 'center' }"
                  class="text-heading-xl"
                  i18n="@@loginView.loginToParticipate"
                >
                  Log in to participate in
                  {{ tenant.name }}
                </h6>
              </div>
              <app-login
                [canSignup]="canSignup"
                [defaultLoggedInUrl]="'/home'"
                [hasSignUpRedirect]="true"
                [tenant]="tenant"
                class="u-display-block u-width-100"
              />
            </div>
          </div>
        </div>
      } @else {
        <div
          [ngStyle]="{ 'max-width': '400px' }"
          class="bg-color-white u-padding-24"
        >
          <app-no-local-storage-prompt class="u-display-block" />
        </div>
      }
    } @else {
      <app-progress-spinner class="u-display-block"></app-progress-spinner>
    }
  </div>
} @else {
  <div
    [ngStyle]="{ 'min-height': '500px', height: '100vh', width: '95vw' }"
    class="u-position-relative u-margin-center"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    @if (tenant) {
      @if (!authService.$isLoggedIn()) {
        <div
          [ngStyle]="{ top: '16px', left: '16px' }"
          class="u-position-absolute"
        >
          <a
            [routerLink]="['/']"
            aria-label="Go home"
            mat-icon-button
            i18n-aria-label="@@loginView.goHome"
          >
            <mat-icon>home</mat-icon>
          </a>
        </div>
      }
      <div [ngStyle]="{ 'min-height': '424px' }">
        @if (canLogIn) {
          <app-login
            [defaultLoggedInUrl]="'/home'"
            [hasSignUpRedirect]="true"
            [tenant]="tenant"
            class="u-display-block u-marginBottom-16"
          >
          </app-login>
          @if (
            !authService.$isLoggedIn() &&
            (tenant.email_login_enabled ||
              tenant.integrations?.workos?.sso_signup_enabled)
          ) {
            @if (canSignup) {
              <p class="u-textAlign-center" i18n="@@loginView.signupPrompt">
                Don't have an account?
                <a
                  [routerLink]="['/signup']"
                  class="color-blue c-button"
                  queryParamsHandling="merge"
                >
                  Sign up
                </a>
              </p>
            }
            @if (tenant.email_login_enabled) {
              <div
                i18n="@@loginView.privacyDisclaimer"
                [ngStyle]="{ 'max-width': '400px' }"
                class="color-grey text-caption u-marginTop-16 u-textAlign-center"
              >
                This site is protected by reCAPTCHA and the Google
                <a class="color-blue" href="https://policies.google.com/privacy"
                  >Privacy Policy</a
                >
                and
                <a class="color-blue" href="https://policies.google.com/terms"
                  >Terms of Service</a
                >
                apply.
              </div>
            }
          }
        } @else {
          <div
            [ngStyle]="{ 'max-width': '400px' }"
            class="bg-color-white u-padding-24"
          >
            <app-no-local-storage-prompt
              class="u-display-block"
            ></app-no-local-storage-prompt>
          </div>
        }
      </div>
    } @else {
      <app-progress-spinner class="u-display-block" />
    }
  </div>
}
